import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Cast = createReactComponent("Cast", ["svg", defaultAttributes, [["path", {
  d: "M2 16.1A5 5 0 015.9 20M2 12.05A9 9 0 019.95 20M2 8V6a2 2 0 012-2h16a2 2 0 012 2v12a2 2 0 01-2 2h-6",
  key: "1v255n"
}], ["line", {
  x1: "2",
  y1: "20",
  x2: "2.01",
  y2: "20",
  key: "1pj7gx"
}]]]);
export default Cast;